<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="版本号：" prop="version">
                <el-input v-model="model.version"></el-input>
            </el-form-item>
            <el-form-item label="是否强制：" prop="is_force">
                <el-select clearable v-model="model.is_force" placeholder="请选择">
                    <el-option v-for="item in enuObj('yesNo')" :key="'yesNo'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input v-model="model.remark"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'appVersionAppleEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                version: '',
                url: '',
                is_force: '',
                remark: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/appversionapple/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['yesNo'],
            rules: {
                xxxname: [
                    {required: true, message: 'xxx名称不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/appversionapple/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        formateData(){
            this.model.is_force = this.model.is_force+""
        },
    }
};
</script>